import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-776ff874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = ["disabled", "placeholder"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      disabled: _ctx.disabled,
      placeholder: _ctx.placeholder,
      type: "text",
      class: "searchbox__entry textbox__entry",
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
      onKeyup: [
        _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
        _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["esc"]))
      ]
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.inputValue]
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["searchbox__reset", !_ctx.inputValue ? 'searchbox__reset--hidden' : undefined]),
      "data-test": "button-searchReset",
      disabled: _ctx.disabled,
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
    }, _hoisted_5, 10, _hoisted_3),
    _createElementVNode("button", {
      class: "searchbox__search",
      "data-test": "button-search",
      disabled: _ctx.disabled || !_ctx.inputValue,
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
    }, _hoisted_8, 8, _hoisted_6)
  ]))
}